
import { STRING_VALUE_TYPE } from './Types';

const CURRENT_USER = '[current]';

const getUserChipLabel = options => (value, props = {}) => {
  let username = value;
  if (value === options.currentUserKey) {
    if (options.currentUserChipValue) {
      return options.currentUserChipValue;
    }
    const { authService } = props;
    username = authService && authService.getUsername() || value;
  }
  return `User: ${username}`;
};

const DisplayToData = options => (value, props = {}) => {
  if (!value) {
    return undefined;
  }
  const { authService } = props;
  const username = authService && authService.getUsername();
  if (username && (username === value) && options.currentUserKey) {
    return options.currentUserKey;
  }
  return value;
};

const DataToDisplay = options => (value, props = {}) => {
  if (!value) {
    return '';
  }
  if (value === options.currentUserKey) {
    const { authService } = props;
    return authService && authService.getUsername() || value;
  }
  return value;
};

const makeUserEditor = (options = {}) => {
  const opts = {
    currentUserKey: CURRENT_USER,
    ...options,
  };

  const { authService } = opts;
  const getCurrentUsername = () => {
    return authService && authService.getUsername();
  };

  const isStandardUser = () => {
    return !authService || (!authService.isAdminRole() && !authService.isReadOnlyRole());
  };

  const { getObjectUsername = o => o.username } = opts;
  const currentUserAsDefault = (options.currentUserAsDefault === undefined)
    || options.currentUserAsDefault;
  const defaultQueryValue = Object.prototype.hasOwnProperty.call(options, 'defaultQueryValue')
    ? options.defaultQueryValue : (currentUserAsDefault && CURRENT_USER || undefined);
  const getDefaultQueryValue = () => {
    if (options.getDefaultQueryValue) {
      return options.getDefaultQueryValue();
    }
    return isStandardUser() ? defaultQueryValue : undefined;
  };

  return {
    name: opts.name || 'username',
    title: opts.title || 'Username',
    type: opts.type || STRING_VALUE_TYPE,
    getValueLabel: getUserChipLabel(opts),
    displayToData: DisplayToData(opts),
    dataToDisplay: DataToDisplay(opts),
    currentUserAsDefault,
    getDefaultQueryValue,
    toFilter: opts && opts.toFilter || ((query) => {
      if (!query) return undefined;
      return getCurrentUsername() === query ? opts.currentUserKey : query;
    }),
    toQuery: opts && opts.toQuery || ((username, server) => {
      if (username === undefined) {
        return server ? null : '';
      }
      return (username === opts.currentUserKey) && getCurrentUsername() || username;
    }),
    createObjectFilter: (username) => {
      if (!username) return () => true;
      if (username === opts.currentUserKey) {
        return o => (getObjectUsername(o) === getCurrentUsername());
      }
      return o => (getObjectUsername(o) === username);
    },
  };
};

export default makeUserEditor;
